/** Preferências locais do jogador (por navegador). Falhas de storage nunca quebram o jogo. */
export function readPref(key: string, fallback: string): string {
  try {
    return window.localStorage.getItem(`eldrun:${key}`) ?? fallback;
  } catch {
    return fallback;
  }
}

export function writePref(key: string, value: string): void {
  try {
    window.localStorage.setItem(`eldrun:${key}`, value);
  } catch {
    // modo privado ou storage bloqueado: segue sem lembrar
  }
}
